__turbopack_context__.v({
  "badge": "JUh2qG_badge",
  "badgeActive": "JUh2qG_badgeActive",
  "button": "JUh2qG_button",
  "buttonActive": "JUh2qG_buttonActive",
});
